import { render, staticRenderFns } from "./Berechnungsergebnisse.vue?vue&type=template&id=1507bc4d"
import script from "./Berechnungsergebnisse.vue?vue&type=script&lang=js"
export * from "./Berechnungsergebnisse.vue?vue&type=script&lang=js"
import style0 from "./Berechnungsergebnisse.vue?vue&type=style&index=0&id=1507bc4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports